export class DashboardPraModels {
  acceptanceDate: string;
  actTerritoryTypeTitle: string;
  title: string;
  regPlanItemId: string;

  constructor(item: any) {
    this.acceptanceDate = item.acceptanceDate;
    this.actTerritoryTypeTitle = item.actTerritoryTypeTitle;
    this.title = item.title;
    this.regPlanItemId = item.regPlanItemId;
  }

  static fromJson(json: any): DashboardPraModels {
    return new DashboardPraModels(json);
  }
}
